import { useCallback } from "react"
import { atom } from "jotai"
import { useAtomValue, useUpdateAtom } from "jotai/utils"

const agencyIdAtom = atom<string | undefined>(
  localStorage.getItem("agencyId") || undefined,
)

export function useAgencyId() {
  const agencyId = useAtomValue(agencyIdAtom)
  const updateAgencyId = useUpdateAtom(agencyIdAtom)

  const setAgencyId = (id: string) => {
    localStorage.setItem("agencyId", id)
    updateAgencyId(id)
  }

  const clearAgencyID = useCallback(() => {
    localStorage.removeItem("agencyId")
    updateAgencyId(undefined)
  }, [updateAgencyId])

  return {
    agencyId,
    setAgencyId,
    clearAgencyID,
  }
}
